import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const WeCare = () => {
  return (
    <>

    </>
  )
};

export default WeCare;
